import { ActionsList } from '@/components/ActionsList';
import Stack from '@/design_system/Stack';
import { ArticleDispatch } from '@/routes/Requests/components/ArticleDispatch';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { ServiceChoice } from './ServiceChoice';
import { ServiceExchange } from './ServiceExchange';
import { ServiceExchangeArchival } from './ServiceExchangeArchival';
import { ServiceNone } from './ServiceNone';
import { ServiceRefund } from './ServiceRefund';

export const ArticleServices = () => {
  const { view } = useArticleContext();

  return (
    <Stack gap="2rem">
      {view.services.choice.shown && <ServiceChoice />}

      {view.services.dispatchBeforeActions ? (
        <>
          {view.services.dispatch.shown && <ArticleDispatch />}
          {view.services.actions.shown && <ActionsList />}
        </>
      ) : (
        <>
          {view.services.actions.shown && <ActionsList />}
          {view.services.dispatch.shown && <ArticleDispatch />}
        </>
      )}

      {view.services.exchange.shown && <ServiceExchange />}
      {view.services.none.shown && <ServiceNone />}
      {view.services.exchangeArchival.shown && <ServiceExchangeArchival />}
      {view.services.refund.shown && <ServiceRefund />}
    </Stack>
  );
};
